module.exports = __webpack_public_path__ + "media/mypage/images/flat/manager-1875ad9bf068ae354ce4736e989ba241.png";